//
// Section.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../BIRDModel";
import "./PageSetup";
import "./Header";
import "./Body";
import "./Footer";
import "./AutoInteractionMode";
import "./SectionVisibility";

var Section = createModule("BIRD::Section", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        pageSetup: 1,
        visibility: 1,
        footer: 1,
        name: 7,
        header: 1,
        autoInteractionMode: 4,
        label: 7,
        body: 1,
        applicationName: 7,
        sections: [1],
        showSelectionControl: 2,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default Section;
